import React, { Fragment, Component } from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { Icon } from '../../Icon';
import { gtmSend } from '../../../../helpers';
import NotificationSystem from 'react-notification-system';
import cx from '../../../../styles';

class CommentInputCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anonymous: false,
            isShowNotification: true,
            isShowNotificationMessage: true,
            buttonColor: '#c8c8c8',
            isClickSubmit: false
        };
        this._notificationSystem = React.createRef();
        this.refCommentContent = React.createRef();
    }

    componentDidMount() {
        if(this.state.isShowNotification){
            if (this.props.eventHandlers.refAddNotification) this.props.eventHandlers.refAddNotification(this._addNotification);
        }
        if(this.state.isShowNotificationMessage){
            if (this.props.eventHandlers.refAddNotificationMessage) this.props.eventHandlers.refAddNotificationMessage(this._addNotificationMessage);
        }
    
        // to bring the focus to the comment popup
        const id = `comment-${this.props.id}`;
        const yOffset = -200; 
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

    componentDidUpdate(){
        if(this.refCommentContent){
            if(this.state.buttonColor == '#c8c8c8' && this.refCommentContent.value){
                this.setState({
                    buttonColor: '#0182f1'
                })
            }
            else if(this.state.buttonColor == '#0182f1' && this.refCommentContent.value == ''){
                this.setState({
                    buttonColor: '#c8c8c8'
                })
            }
        }
    }

    _addNotification = (message, level) => {
        if(this.state.isShowNotification){
            this.setState({isShowNotification: false})
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 3,
                position: 'tc'
            });
            setTimeout(()=>{
                this.setState({isShowNotification: true})
            }, 3000)
        }
    }
    
    _addNotificationMessage = (message, level) => {
        if(this.state.isShowNotificationMessage){
            this.setState({isShowNotificationMessage: false})
            this._notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 10,
                position: 'tc'           
            })
            setTimeout(()=>{
                this.setState({isShowNotificationMessage: true})
            }, 10000)
        }
    }

    onFormSubmitClick = (e) => {
        if (this.props.eventHandlers.onSubmit) {
            if(!this.state.isClickSubmit) {
                if(this.props.content && !this.props.content.includes('covid')){
                    this.setState({isClickSubmit : true})
                }
                this.props.eventHandlers.onSubmit(e);
            }
        }
    }

    render(){
        const {t, author, content, gtmLabel, id, showAnonymous = true} = this.props;
        const {onContentChange, onCloseClick} = this.props.eventHandlers;
    	
        return (
            <Fragment>
                <NotificationSystem ref={n => this._notificationSystem = n} />
        		<form onSubmit={this.onFormSubmitClick} className={cx("comment-popup")} id={"comment-" + id}>
                    <div className={cx("reply-to")}>
                        <div className={cx("reply-to-text")}>
                            {t('replying_to')}
                            {
                                author.fullname && author.fullname.toLowerCase() != 'anonymous'
                                ?
                                    <a href={this.props.siteUrl + author.slug} rel="nofollow" className={cx('reply-author-feed')}>
                                        {' @' + author.fullname}
                                    </a>
                                :
                                    <span>{' @' + author.fullname}</span>

                            }
                        </div>
                        <div onClick={onCloseClick} className={cx("close")}>
                            <Icon name="cross-regular-dark-smd" />
                        </div>
                    </div>
                    <div className={cx("input-content")}>
                        <input type="hidden" name="anonymous" value={this.state.anonymous} />
                        <textarea
                            ref={input => this.refCommentContent = input}
                            className={cx("txtbox")}
                            value={content}
                            onClick={() => gtmSend('dynamic', gtmLabel, 'click-content', '')}
                            onChange={(e) => onContentChange(e.target.value)}
                            placeholder={t('add_reply_second_level_placeholder')} />
                        <button type="submit" className="send-btn">
                            <Icon name="send-btn" color={this.state.buttonColor} />
                        </button>
                    </div>
                    {
                        showAnonymous &&
                        <div className={cx("btn-check-label")}>
                            <input id="anonymous-input" checked={this.state.anonymous} onChange={e => {this.setState({anonymous: +e.target.checked}); gtmSend('dynamic', gtmLabel, 'click-anonymous', +e.target.checked)}} type="checkbox" />
                            <label htmlFor="anonymous-input" className={cx("pointer-click")}>{t('post_anonymously')}</label>
                        </div>
                    }
                </form>
            </Fragment>
    	)
    }
}

export default translate()(CommentInputCard);